var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "90 28 105 50",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1132 -651)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.896226 0 0 0.767857 210.679245 173.142857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1180.863,720L1157.989,720C1144.749,720 1134,707.454 1134,692C1134,676.546 1144.749,664 1157.989,664L1180.863,664M1194.253,664L1216.011,664C1229.251,664 1240,676.546 1240,692C1240,707.454 1229.251,720 1216.011,720L1194.253,720",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 9.99
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.025641 0 0 1 57.051282 13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1168,692L1207,692",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 8.23
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.1e3e687e471c4f8fc7b3c5d89e81f35a.svg";
export { ForwardRef as ReactComponent };